module.exports = __webpack_public_path__ + "static/media/PsychicGameTextImage.bf6c2cb0.png";